import React from 'react';
import { Link } from 'react-router-dom';
import Layout from './components/Layout';

function TermsOfUse() {
  return (
    <Layout>

      {/* Content */}
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl font-bold text-neutral-900 mb-8">Terms of Use</h1>
          
          <div className="prose prose-neutral max-w-none">
            <p className="text-lg text-neutral-600 mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-neutral-800 mb-4">Important Notice</h2>
              <p className="text-neutral-600 mb-4">
                This is a <strong>test page</strong> for demonstration purposes only. The paisa.io EMI calculator 
                and all associated tools are provided "as is" without any warranties or guarantees.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-neutral-800 mb-4">Use at Your Own Risk</h2>
              <p className="text-neutral-600 mb-4">
                By using this website and its tools, you acknowledge and agree that:
              </p>
              <ul className="list-disc pl-6 text-neutral-600 space-y-2">
                <li>You use this service entirely at your own risk</li>
                <li>The calculations and results provided are for informational purposes only</li>
                <li>You should not rely solely on these calculations for financial decisions</li>
                <li>Always consult with qualified financial professionals before making important financial decisions</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-neutral-800 mb-4">Disclaimer</h2>
              <p className="text-neutral-600 mb-4">
                The developers and operators of paisa.io make no representations or warranties about:
              </p>
              <ul className="list-disc pl-6 text-neutral-600 space-y-2">
                <li>The accuracy, completeness, or reliability of any calculations</li>
                <li>The fitness of this tool for any particular purpose</li>
                <li>The availability or uptime of the service</li>
                <li>The security or privacy of data entered into the calculator</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-neutral-800 mb-4">Test Environment</h2>
              <p className="text-neutral-600 mb-4">
                This website is currently in a testing phase. Features may be incomplete, calculations may contain 
                errors, and the service may be unavailable at times. Do not use this for actual financial planning 
                without independent verification.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-neutral-800 mb-4">Limitation of Liability</h2>
              <p className="text-neutral-600 mb-4">
                In no event shall paisa.io, its developers, or operators be liable for any direct, indirect, 
                incidental, special, or consequential damages arising from your use of this website or reliance 
                on any information provided herein.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-neutral-800 mb-4">Changes to Terms</h2>
              <p className="text-neutral-600 mb-4">
                These terms may be updated at any time without notice. Your continued use of the website 
                constitutes acceptance of any changes.
              </p>
            </section>

            <div className="mt-18 pt-8 border-t border-neutral-200">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-primary-dark transition-colors"
              >
                ← Back to Calculator
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default TermsOfUse;